import { jsx as _jsx } from "react/jsx-runtime";
import { Ellipsis } from "lucide-react";
import { Icon } from "../icons.js";
import { Menu } from "./Menu.js";
/**
 * A `⋯` button that owns a {@link Menu} (design-spec §4 "Menu", "⋯ on session"; variant E
 * `.ve-ibtn`): 36px square, radius 6, the glyph in ink-1, no fill at rest; hovered or open it
 * fills `--tone` through `--more-bg` (`interactions.css`). The menu's keyboard, dismissal and
 * panel are `Menu`'s. No accent: it is a menu trigger (§4 Don't, accent on menu items).
 */
export function MoreMenu({ items, label, disabled = false, ...rest }) {
    return (_jsx(Menu, { label: label, items: items, trigger: (props) => (_jsx("button", { ...props, ...rest, type: "button", "data-more": "", "aria-label": label, disabled: disabled, style: {
                width: 36, height: 36, padding: 0, margin: 0, border: "none",
                display: "grid", placeItems: "center", borderRadius: "var(--radius-control)",
                background: "var(--more-bg, transparent)", color: disabled ? "var(--ink-3)" : "var(--ink-1)",
                cursor: disabled ? "default" : "pointer",
                transition: "background-color var(--dur-fast) var(--ease-out)",
            }, children: _jsx(Icon, { icon: Ellipsis, size: 20, "aria-hidden": "true" }) })) }));
}
